document.addEventListener("alpine:init", () => {
    Alpine.data("postMetaBar", () => ({
        showAllTags: false,
        copied: false,
        copyURLToClipboard() {
            navigator.clipboard.writeText(window.location.href).then(
                () => {
                    this.copied = true;
                    setTimeout(() => (this.copied = false), 2000);
                },
                () => {
                    /* clipboard write failed */
                },
            );
        },
    }));
});
